import { v4 as uuidv4 } from "uuid";

function PickState<T>(keys: Array<keyof T>) {
    return (state: T): Pick<T, keyof T> => {
        let obj: any = [];
        keys.forEach((key) => {
            obj[key] = state[key];
        });
        return obj;
    };
}

export default PickState;

export function uuid() {
    return uuidv4().replace(/-/gi, "");
}
